// Client-side popup frequency cap + A/B bucketing, persisted per browser session.
// No PostHog needed: sessionStorage resets when the tab/session ends.

const VARIANT_KEY = 'aibc_course_popup_variant'

export type PopupVariant = 'offer' | 'magnet'

// Stable 50/50 coin flip for the session. Same reader sees the same variant
// across every course article until the session ends.
export function getSessionVariant(): PopupVariant {
  try {
    const existing = sessionStorage.getItem(VARIANT_KEY)
    if (existing === 'offer' || existing === 'magnet') return existing
    const picked: PopupVariant = Math.random() < 0.5 ? 'offer' : 'magnet'
    sessionStorage.setItem(VARIANT_KEY, picked)
    return picked
  } catch {
    return 'magnet'
  }
}

// Frequency cap shared across all course articles in the session.
export function canShowCapped(capKey?: string, max = 2): boolean {
  if (!capKey) return true
  try {
    return Number(sessionStorage.getItem(capKey) || 0) < max
  } catch {
    return true
  }
}

export function recordCappedShow(capKey?: string): void {
  if (!capKey) return
  try {
    const n = Number(sessionStorage.getItem(capKey) || 0)
    sessionStorage.setItem(capKey, String(n + 1))
  } catch {}
}
